module.exports = __webpack_public_path__ + "assets/media/swallow_split_new_light.2b0a1fa1.mp4";